import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';
import { api } from 'trpc/react';
import { revalidateTag } from '~/shared/lib';

export const useInvalidateAll = () => {
    const utils = api.useUtils();
    const router = useRouter();

    const mutation = useMutation({
        mutationKey: ['invalidateAll'],
        mutationFn: async () => {
            revalidateTag('getPage');
            revalidateTag('countProducts');
            revalidateTag('getAllProducts');
            revalidateTag('getProductBySlug');
            revalidateTag('getAllColors');
            revalidateTag('getAllBrands');
            revalidateTag('getAllSizes');
            revalidateTag('getAllCategories');
            revalidateTag('getSubOrSiblingCategories');
            revalidateTag('getAllLists');

            await Promise.all([
                utils.product.getProductsInfinite.invalidate(void 0, { refetchType: 'all' }),

                utils.color.getAll.invalidate(void 0, { refetchType: 'all' }),
                utils.brand.getAll.invalidate(void 0, { refetchType: 'all' }),
                utils.size.getRowFilters.invalidate(void 0, { refetchType: 'all' }),

                utils.category.getAll.invalidate(void 0, { refetchType: 'all' }),
                utils.category.getSubOrSiblingCategories.invalidate(void 0, { refetchType: 'all' }),
                utils.category.getBySlug.invalidate(void 0, { refetchType: 'all' }),
            ]);
        },
        onMutate: () => {
            const toastId = toast.loading('Обновление кэша');
            return { toastId };
        },
        onSuccess: (_, __, ctx) => {
            toast.success('Кэш успешно обновлён', { id: ctx?.toastId });
            router.refresh();
        },
        onError: (_, __, ctx) => {
            toast.error('Не удалось обновить кэш', { id: ctx?.toastId });
        },
    });

    return mutation;
};
